module.exports = __webpack_public_path__ + "__static/site-1783523783704/img/lion-english.fb3b054a.jpg";